<div class="bg-white d-flex flex-column justify-content-center inline-alerts">
  @for (alert of inlineAlerts(); track alert?.id ?? alert) {
    <mbs-alert
      class="content-center mb-1"
      [class.mb-1]="!$last"
      [autoClose]="alert.autoClose"
      [closable]="true"
      [alertRef]="alert"
      [content]="alert.content"
      [context]="alert.context"
      [icon]="true"
      [ignoreRouteChanges]="alert.ignoreRouteChanges"
      [type]="alert.type"
      [id]="alert.id"
      (close)="removeAlert($event)" />
  }
</div>
<div class="d-flex flex-row justify-content-center overlay-alerts">
  <div class="position-fixed text-center">
    @for (alert of overlayAlerts(); track alert?.id ?? alert) {
      <div>
        <mbs-alert
          class="d-inline-flex text-start"
          [autoClose]="alert.autoClose"
          [class.mb-0]="$last"
          [closable]="true"
          [alertRef]="alert"
          [content]="alert.content"
          [context]="alert.context"
          [icon]="true"
          [ignoreRouteChanges]="alert.ignoreRouteChanges"
          [type]="alert.type"
          [id]="alert.id"
          (close)="removeAlert($event)" />
      </div>
    }
  </div>
</div>
